export default "__VITE_ASSET__pHE6V_z8__"